import { useHttp } from '@/composables/useHttp'
import type { PaginatedResponse, PaginationRequest } from '@/composables/useIndexRequest'

export type BlogCategory = {
  id: number
  name: string
  created_at: string // ISO8601
  updated_at: string // ISO8601
}

export type IndexBlogPost = {
  id: number

  category: {
    id: number
    name: string
  } | null
  image_url: string | null
  title: string
  excerpt: string
  slug: string
  author: string
  created_at: string // ISO8601
  updated_at: string // ISO8601
}

export type ShowBlogPost = {
  id: number
  category: {
    id: number
    name: string
  }
  image_url: string | null
  title: string

  content: string
  excerpt: string

  slug: string
  author: string
  published_at: string // ISO8601
  created_at: string // ISO8601
  updated_at: string // ISO8601
}

export const useBlogHttp = () => {
  const http = useHttp()

  const index = async (params: PaginationRequest & { blog_category_id?: number }) => {
    return (
      await http.get<PaginatedResponse<IndexBlogPost>>('/blog-posts', {
        params,
      })
    ).data
  }

  const show = async (slug: IndexBlogPost['slug']) => {
    return (await http.get<{ data: ShowBlogPost }>(`/blog-posts/${slug}`)).data
  }

  const categories = async () => {
    return (await http.get<{ data: BlogCategory[] }>('/blog-categories')).data
  }

  return {
    index,
    show,
    categories,
  }
}
